// main.js

import { headerMenu } from "./components/header.js";
import { fullVideoSection } from "./components/full-video-section.js";
  import { cardSwiper } from "./components/cardSwiper.js";
  import { textReveal } from "./components/textReveal.js";
  import {stackedCards} from "./components/stackedCards.js";
  import { loader} from "./components/loader.js";
  import { banner } from "./components/banner.js";
  import { counterSwiper } from "./components/counterSwiper.js";
  import { accordionInit } from "./components/accordion.js";  
  import { growthStatsSwiper } from "./components/growthStatsSwiper.js";
  import { agendaTabs } from "./components/agenda-tabs.js";
  import { eventKeywordsSwiper } from "./components/eventKeywordsSwiper.js";
  import { productSectorsSwiper } from "./components/productSectorsSwiper.js";
  import { ticker } from "./components/ticker.js";
  import { tickerSlider } from "./components/ticker-slider.js";
  import { videoHighlightSwiper } from "./components/video-highlight.js";
  import { testimonialSlider } from "./components/testimonial-slider.js";
  import { tagsSwiper } from "./components/tags-swiper.js";
  import { glightbox } from "./components/glightbox.js";
  import { innerBanner } from "./components/inner-banner.js";
  import { scrolldownArrow } from "./components/scrolldown-arrow.js";

document.addEventListener("DOMContentLoaded", () => {
  loader();
  banner();
  headerMenu();
  fullVideoSection();
  cardSwiper();
  textReveal();
  stackedCards();
  counterSwiper();
  accordionInit();
  growthStatsSwiper();
  agendaTabs();
  eventKeywordsSwiper();
  productSectorsSwiper();
  ticker();
  tickerSlider();
  videoHighlightSwiper();
  testimonialSlider();
  tagsSwiper();
  glightbox();
  innerBanner();
  scrolldownArrow();
});